import React, { useEffect, useRef, useState } from "react";
import ProductPromotionFooter from "../../../../common/productPromotionFooter/ProductPromotionFooter";
import "./ProductSearch.scss";
import CartIcon from "../../CartIcon";
import PromotionSearchBar from "../../../../common/promotionSearchBar/PromotionSearchBar";
import { useDispatch, useSelector } from "react-redux";
import { emptyPromotionSearch, fetchProductDetails, fetchPromotionSearchKeywords, fetchPromotionSearchProducts } from "../../../../thunk/lineOrdering.thunk";
import PromotionSearchMenu from "../../../../common/promotionSearchMenu/PromotionSearchMenu";
import queryString from 'query-string';
import { useLocation, useHistory } from "react-router-dom";
import Product, { ProductItemType } from "../../PromotionTemplate/Product";
import { PromotionSearchScroller } from "./PromotionSearchScroller";
import { SkeletonLoader } from "../../../../common";
import commonConstant, { LINE_ORDERING_TABS_MAPPING, PROMOTION_SEARCH_LABELS, SESSION_KEY } from "../../../../common/commonConstant";
import { addProductsToCart, addProductsToCartPublic, getCartId, getPriceFormat, INSTALLMENT_TYPE, STOCK_STATUS } from "../../../../services/promotion/utils.service";
import { getCartData, updateCartData } from "../../../../actions/cartAction";
import LoadingOverlay from "react-loading-overlay";
import HnWSlideup from "../../../../common/slideup/HnWSlideup";
import { UpdateState } from "../../SelectProduct/PromotionProduct";
import CustomSweetAlert from "../../../../common/customSweetAlert/CustomSweetAlert";

export default function ProductSearch() {
    const minLength = 1;
    const maxLength = 30;
    const pageSize = 10;

    const { promotionSearchProducts, promotionSearchKeywords, searchProductsLoading, searchSuggestionLoading } = useSelector((state) => state.lineOrdering.PROMOTION_SEARCH)
    const { productDetailData, loading: detailLoading } = useSelector((state) => state.lineOrdering.PRODUCT_DETAIL)

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const params = queryString.parse(location.search);
    const openSearch = params['openSearch'];

    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [searchKey, setSearchKey] = useState('');
    const [showAllList, setShowAllList] = useState(false);
    const [pageStart, setPageStart] = useState({
        recommendedProducts: 1,
    });
    const [selectedSearchKey, setSelectedSearchKey] = useState('');
    const [listLoading, setListLoading] = useState(false);

    const [cart, setCart] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isFOAEmpty, setIsFOAEmpty] = useState(false);
    const [cartEntries, setCartEntries] = useState(0);
    const [accountType, setAccountType] = useState(null);
    const [totalPrice, setTotalPrice] = useState(0);
    const [totalPointValue, setTotalPointValue] = useState(0);
    const [totalBusinessVolume, setTotalBusinessVolume] = useState(0);
    const [totalSelected, setTotalSelected] = useState(0);
    const [searchedProducts, setSearchedProducts] = useState([]);
    const [productsAdded, setProductsAdded] = useState([]);

    const searchRef = useRef(null);
    const searchInputRef = useRef(null);
    const timeoutHandler = useRef(null);
    const shouldFetchProducts = useRef(false);

    useEffect(() => {
        if (openSearch && searchInputRef.current) {
            searchInputRef.current.focus();
            setIsSearchOpen(true);
        }
    }, [openSearch]);

    useEffect(() => {
        document.addEventListener('click', handleCloseMenu);
        return () => {
            document.removeEventListener('click', handleCloseMenu);
        };
    }, []);

    useEffect(() => {
        if (searchKey) {
            setSelectedSearchKey('');
            dispatch(emptyPromotionSearch());
            dispatch(
                fetchPromotionSearchKeywords({
                    keyword: searchKey,
                }))
                .finally(() => {
                    setShowAllList(true);
                });
            shouldFetchProducts.current = true;
            setPageStart((prev) => ({ ...prev, recommendedProducts: 1 }));
        }
    }, [searchKey]);

    useEffect(() => {
        if (!selectedSearchKey) return;

        dispatch(emptyPromotionSearch());
        shouldFetchProducts.current = true;
        setPageStart((prev) => ({ ...prev, recommendedProducts: 1 }));

    }, [selectedSearchKey]);

    useEffect(() => {
        if (shouldFetchProducts.current) {
            shouldFetchProducts.current = false;
            getRecommendedProducts();
        }
    }, [pageStart]);

    useEffect(() => {
        if (!promotionSearchProducts?.data) return;

        setSearchedProducts((prevSearchedProducts) => {
            const updatedProducts = promotionSearchProducts?.data?.map((product) => {
                const addedProduct = productsAdded.find((p) => p.id === product.id);
                return addedProduct ? { ...product, quantity: addedProduct.quantity, kitEntries: addedProduct.kitEntries } : product;
            });

            if (JSON.stringify(prevSearchedProducts) === JSON.stringify(updatedProducts)) return prevSearchedProducts;

            return updatedProducts;
        });
    }, [promotionSearchProducts?.data, productsAdded]);

    useEffect(() => {
        const didMount = async () => {
            try {
                let cartData;
                const customerFOA = JSON.parse(sessionStorage.getItem('customerFOAData'));
                if (!customerFOA) {
                    setIsFOAEmpty(true);
                }
                await dispatch(getCartData("FULL", getCartId(params['isInstallment']))).then(res => cartData = res)
                if (cartData && cartData.length) {
                    setCart(cartData[0]);
                    setAccountType(cartData[0].account?.accountType);
                    let totalEntries = cartData[0]?.entries?.reduce((sum, item) => sum + item.quantity, 0) || 0;
                    setCartEntries(totalEntries);
                }
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        }
        didMount();
    }, []);

    const handleAddToCart = async () => {
        if (totalPrice === 0) {
            return;
        }

        await handleFullPayment();
    }

    const handleFullPayment = async () => {
        setLoading(true);

        const cartId = sessionStorage.getItem(SESSION_KEY.pifCartId);
        const customerFOA = JSON.parse(sessionStorage.getItem('customerFOAData'));

        const response = !customerFOA
            ? await addProductsToCart(cartId, productsAdded)
            : await addProductsToCartPublic(
                cartId,
                productsAdded,
                cart?.guid,
            );

        sessionStorage.setItem('guid', cart?.guid);
        setLoading(false);

        if (response.error) {
            setLoading(false);
            return CustomSweetAlert({
                title: "",
                text: response.error[0].th_message,
                confirmButtonText: "ตกลง",
            });
        }
        //Update latest cartData to redux
        await dispatch(updateCartData([response.data]));
        goToCart();
    }

    const goToCart = () => {
        const urlParams = new URLSearchParams(location.search);
        urlParams.set(SESSION_KEY.isInstallment, INSTALLMENT_TYPE.FALSE);
        history.push({ pathname: commonConstant.pathCartPromotion, search: urlParams.toString() });
    }

    const setQuantityToProduct = (product, quantity) => {
        product.quantity = quantity;

        if (product.kitEntries?.length > 0) {
            product.kitEntries.forEach((kitEntry) => {
                const configuredQty = kitEntry.configuredQty;

                if (kitEntry.product?.baseOptions?.length > 0) {
                    const baseOptions = kitEntry.product.baseOptions[0];
                    let qtyFlag = false;

                    for (const [index, option] of baseOptions.options.entries()) {
                        if (kitEntry.product.baseProduct) {
                            if (baseOptions.selectedId) {
                                const qty = baseOptions.selectedId === option.id ? configuredQty : 0;
                                option.quantity = qty;
                                option.lastQuantity = qty;
                            }
                        } else {
                            let qty = 0;
                            if (!qtyFlag && option.stock?.stockLevelStatus !== STOCK_STATUS.outOfStock) {
                                qty = configuredQty;
                                qtyFlag = true;
                            }
                            option.quantity = qty;
                            option.lastQuantity = qty;
                        }
                    };
                }
            });
        }

        return product;
    };

    const setProductSelected = async (productId, quantity, updateState, rootProductId) => {
        let updatedKitEntries = [];

        const baseProduct = searchedProducts?.find(p => p.id === productId);

        if (baseProduct?.isKitProduct && quantity > 0) {
            setLoading(true);
            const product_details = await dispatch(fetchProductDetails(productId));
            updatedKitEntries = product_details.kitEntries || [];

            setQuantityToProduct({ ...product_details, kitEntries: updatedKitEntries }, quantity);
            setLoading(false);
        }
        setSearchedProducts((prevRelatedProducts) => {
            if (!prevRelatedProducts) return [];

            const updatedProducts = prevRelatedProducts.map((product) => {
                if (product.id === productId) {
                    product.quantity = quantity;
                    if (updatedKitEntries.length > 0) {
                        product.kitEntries = updatedKitEntries;
                    }
                }

                if (product.kitEntries?.length > 0) {
                    product.kitEntries.forEach((kitEntry) => {
                        if (kitEntry.product?.baseOptions?.length > 0) {
                            const baseOptions = kitEntry.product.baseOptions[0];

                            baseOptions.options.forEach((option) => {
                                if (kitEntry.kitEntryCode?.includes(rootProductId)) {
                                    if (updateState === UpdateState.FINISH) {
                                        option.lastQuantity = option.quantity;
                                    } else if (option.id === productId) {
                                        if (updateState === UpdateState.CLEAR) {
                                            option.quantity = option.lastQuantity;
                                        }
                                        if (updateState === UpdateState.CHANGE) {
                                            option.quantity = quantity;
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
                return product;
            });

            const updatedProduct = updatedProducts.find((product) => product.id === productId);

            if (!updatedProduct) return updatedProducts;

            setProductsAdded((prevProductsAdded) => {
                const existingProductIndex = prevProductsAdded.findIndex((p) => p.id === productId);

                if (existingProductIndex !== -1) {
                    return prevProductsAdded.map((p) =>
                        p.id === productId ? { ...p, quantity } : p
                    );
                } else {
                    return [...prevProductsAdded, updatedProduct];
                }
            });

            return updatedProducts;
        });
    };


    const handleBackClick = () => {
        history.push(`${commonConstant.pathLineOrdering}?active=${LINE_ORDERING_TABS_MAPPING.Regular.name}`);
    }

    const handleCloseMenu = (e) => {
        if (searchRef.current && !searchRef.current.contains(e.target)) {
            setIsSearchOpen(false);
        }
    };

    const debounce = (callback, delay) => {
        return function (...args) {
            if (timeoutHandler.current) {
                clearTimeout(timeoutHandler.current);
            }
            timeoutHandler.current = setTimeout(() => {
                callback(...args);
            }, delay);
        };
    };

    // Debounced search function
    const handleSearch = debounce((searchQuery) => {
        setSearchKey(searchQuery);

    }, 1000);

    const handleSearchChange = (e) => {
        const searchQuery = e.target.value;
        if (searchQuery) {
            setIsSearchOpen(true);
            handleSearch(searchQuery);
        } else {
            if (timeoutHandler.current) {
                clearTimeout(timeoutHandler.current);
            }
            dispatch(emptyPromotionSearch());
        }
    };

    const handleSearchClick = () => {
        if (!searchInput) {
            dispatch(emptyPromotionSearch());
        }
        setIsSearchOpen(true);
    };

    const handleListClick = (data, flag) => {
        setSelectedSearchKey(data.keyword);
        setSearchInput(data.keyword);
        setSearchKey('');
        setIsSearchOpen(false);
    };

    const getRecommendedProducts = () => {
        setListLoading(true);
        const recordsTotal = promotionSearchProducts.total;
        const loadedDataLength = promotionSearchProducts?.data?.length;
        if (recordsTotal > 0 && loadedDataLength >= recordsTotal) {
            setListLoading(false);
            return;
        }

        dispatch(fetchPromotionSearchProducts({
            keyword: searchKey || selectedSearchKey,
            currentPage: pageStart.recommendedProducts,
            perPage: pageSize,
        })).then(() => {
            setPageStart((prev) => ({
                ...prev,
                recommendedProducts: prev.recommendedProducts + 1,
            }));
        }).finally(() => {
            setListLoading(false);
        });
    };

    const renderRecommendedProducts = (searchedProducts) => {
        if (searchedProducts && searchedProducts.length === 0) {
            return <></>;
        }

        const props = {
            totalPrice: totalPrice,
            setTotalPrice: setTotalPrice,
            totalPointValue: totalPointValue,
            setTotalPointValue: setTotalPointValue,
            totalBusinessVolume: totalBusinessVolume,
            setTotalBusinessVolume: setTotalBusinessVolume,
            totalSelected: totalSelected,
            productItemType: ProductItemType.SELECT,
            setTotalSelected: setTotalSelected,
            setProductSelected: setProductSelected,
        };

        return <PromotionSearchScroller
            items={searchedProducts}
            loading={listLoading}
            itemComponent={Product}
            cartData={cart}
            fetchData={getRecommendedProducts}
            itemProps={props} />
    };

    return (
        <div className="promotion-product-search-container">
            <LoadingOverlay
                text="Loading"
                spinner
                active={loading}
                styles={{ wrapper: { width: '100%', minHeight: '100%' } }}
            />
            <div className="product-search-container-body">
                <div className="product-search-container-main">
                    <div className='search-back-icon-circle' onClick={() => handleBackClick()}>
                        <img src='/images/challenge/arrow-black.svg' />
                    </div>
                    <div ref={searchRef} className="search-suggestions-container">
                        <PromotionSearchBar
                            searchInput={searchInput}
                            setSearchInput={setSearchInput}
                            ref={searchInputRef}
                            handleSearchChange={handleSearchChange}
                            handleSearchClick={handleSearchClick}
                            minLength={minLength}
                            maxLength={maxLength} />
                        {isSearchOpen && searchInput && (
                            <PromotionSearchMenu
                                searchedKeywords={promotionSearchKeywords}
                                searchInput={searchInput}
                                handleListClick={handleListClick}
                                showAllList={showAllList}
                                loading={searchSuggestionLoading}
                            />
                        )}
                    </div>
                    <div className="cart-icon-circle">
                        <CartIcon isFOAEmpty={isFOAEmpty} />
                    </div>
                </div>
                {searchKey && (
                    <div className="recommended-products-list">
                        {searchProductsLoading && searchedProducts?.length == 0 ? (
                            <>
                                {Array.from({ length: 4 }).map((_, idx) => (
                                    <SkeletonLoader key={idx} className="recommended-placeholder-class" />
                                ))}
                            </>
                        ) : searchedProducts?.length > 0 ? (
                            <>
                                <div className="recommended-products-list-heading">
                                    {PROMOTION_SEARCH_LABELS.RECOMMENDED_PRODUCTS_HEADER}
                                </div>
                                {renderRecommendedProducts(searchedProducts)}
                            </>
                        ) : null}
                    </div>
                )}
                {selectedSearchKey && (
                    <div className="recommended-products-list">
                        {searchProductsLoading && searchedProducts?.length == 0 ? (
                            <>
                                {Array.from({ length: 4 }).map((_, idx) => (
                                    <SkeletonLoader key={idx} className="recommended-placeholder-class" />
                                ))}
                            </>
                        ) : searchedProducts?.length > 0 ? (
                            <>
                                <div className="recommended-products-list-heading">{`${PROMOTION_SEARCH_LABELS.SEARCH_RESULTS_HEADER} "${selectedSearchKey}"`}</div>
                                {renderRecommendedProducts(searchedProducts)}
                            </>
                        ) : null}
                    </div>
                )}
            </div>
            <HnWSlideup scrollHide={true} bottomGap="109px" />
            <ProductPromotionFooter amount={getPriceFormat(totalPrice)} pv={totalPointValue.toLocaleString()} bv={totalBusinessVolume.toLocaleString()} handleAddToCart={handleAddToCart} />
        </div>
    )
}